import React from "react";

const UsageNavIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0.5C0.895431 0.5 0 1.39543 0 2.5V12.413C0 13.5176 0.895431 14.413 2 14.413H14C15.1046 14.413 16 13.5176 16 12.413V2.5C16 1.39543 15.1046 0.5 14 0.5H2ZM10.4348 4.67395C10.0506 4.67395 9.73914 4.9854 9.73914 5.3696V8.84786C9.73914 9.23206 10.0506 9.54352 10.4348 9.54352C10.819 9.54352 11.1304 9.23206 11.1304 8.84786V5.3696C11.1304 4.9854 10.819 4.67395 10.4348 4.67395ZM4.17392 8.15219C4.17392 7.768 4.48537 7.45654 4.86957 7.45654C5.25377 7.45654 5.56522 7.768 5.56522 8.15219V8.84785C5.56522 9.23205 5.25377 9.5435 4.86957 9.5435C4.48537 9.5435 4.17392 9.23205 4.17392 8.84785V8.15219ZM7.65218 6.06519C7.26798 6.06519 6.95653 6.37664 6.95653 6.76084V8.84779C6.95653 9.23199 7.26798 9.54345 7.65218 9.54345C8.03638 9.54345 8.34783 9.23199 8.34783 8.84779V6.76084C8.34783 6.37664 8.03638 6.06519 7.65218 6.06519Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { UsageNavIcon };
